import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import CreateBooth from "../views/CreateBooth";
import BoothBoard from "../views/BoothBoard";
import UserTrackingActRevamp from "../views/UserTrackingAct-Revamp";
import UserTrackingResult from "../views/UserTrackingResult";
import BoothReport from "../views/BoothReport";
import VisitorReport from "../views/VisitorReport";
import AdminBoothListView from '../views/AdminBoothListView'
import FirmLogin  from "../views/FirmLogin";
import ShowInformation from "../views/ShowInformation";
import FirmEvent from "../views/FirmEvent";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/CreateBooth",
    name: "CreateBooth",
    component: CreateBooth,
  },
  {
    path: "/BoothBoard/:boothId",
    name: "BoothBoard",
    component: BoothBoard,
  },
  {
    path: "/BoothBoardVisit/:boothId",
    name: "UserTrackingActRevamp",
    component: UserTrackingActRevamp,
  },
  {
    path: "/BoothBoardAdmission/:boothId",
    name: "BoothBoardAdmission",
    component: UserTrackingResult,
  },
  {
    path: "/BoothReport/:queryId(.*)",
    name: "BoothReport",
    component: BoothReport,
  },
  {
    path: "/VisitorReport/:queryId(.*)",
    name: "VisitorReport",
    component: VisitorReport,
  },
  {
    path: "/AdminBoothListView/:showId",
    name: "AdminBoothListView",
    component: AdminBoothListView,
  },
  {
    path: "/FirmLogin/:showId",
    name: "FirmLogin",
    component: FirmLogin,
  },
  {
    //path: "/ShowInformation/:showId/:boothId/:token",
    path: "/ShowInformation/",
    name: "ShowInformation",
    component: ShowInformation,
  },
  {
    path: "/FirmEvent/",
    name: "FirmEvent",
    component: FirmEvent,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
